import { motion } from "framer-motion";
import DAY_girl from "../../assets/girl_cropped.png"
import "../../css/about.css";


// Animation timings
const ease = "easeOut";
const dur = 0.55;

const headlineVariants = {
  hidden: { opacity: 0, y: 24 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: dur, ease },
  },
};

const leftColVariants = {
  hidden: { opacity: 0, x: -40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: dur, ease, delay: 0.1 },
  },
};

const rightColVariants = {
  hidden: { opacity: 0, x: 40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: dur, ease, delay: 0.2 },
  },
};

export default function HeroHistorySection() {
  return (
    <section className="hero-history">
      <motion.div
        className="hero-history__inner"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.35 }}
      >
        {/* Top Headline */}
        <motion.header
          className="hero-history__headline-wrapper"
          variants={headlineVariants}
        >
          <p className="hero-history__eyebrow">ABOUT DAY</p>
          <h1 className="hero-history__title">
            At Dear Asian Youth, We strive to uplift communities through education, activism, and celebration
          </h1>
        </motion.header>

        {/* Two-column content */}
        <div className="hero-history__row">
          {/* Left column: stacked images */}
          <motion.div className="hero-history__left" variants={leftColVariants}>
            <div className="hero-history__image-card">
            <img src={DAY_girl} alt="DAY Logo" className="hero-history__img" />
            </div>
          </motion.div>

          {/* Right column: history text */}
          <motion.div className="hero-history__right" variants={rightColVariants}>
            <h2 className="hero-history__kicker">
              History of DAY
            </h2>
            <p className="hero-history__body hero-history__body--spaced">
              Dear Asian Youth was founded in May of 2020 by Stephanie Hu,
              a 16-year-old who wished to create a platform to publish her poetry.
              It evolved into a blog dedicated to the Asian narrative, then a
              literary magazine, then a full-fledged organization with over 100
              members on the national team.
            </p>
            <p className="hero-history__body"> The organization
              today is the result of passionate volunteers with a shared purpose.</p>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
}
